<template>
  <b-collapse :key="componentKey" class="panel">
    <!-- <div slot="trigger" class="panel-heading">
      <strong>Contratti prodotti</strong>
    </div>-->
    <div class="panel-block">
      <table class="table is-fullwidth is-narrow">
        <!-- <thead>
          <tr>
            <th>Prodotto</th>
            <th>Qt.</th>
            <th>Seriale</th>
            <th></th>
          </tr>
        </thead>-->
        <tbody>
          <tr v-for="(contract, key) in formData" :key="contract.id">
            <td>
              <b-field
                :message="showErrors[key]['course']"
                :type="showErrors[key]['course'] ? 'is-danger' : ''"
              >
                <b-select
                  v-model="contract.type"
                  expanded
                  placeholder="Tipo corso"
                  size="is-small"
                >
                  <option
                    v-for="course in courses.results"
                    :key="course.id"
                    :value="course.id"
                  >
                    {{ course.code }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td width="120px">
              <b-field
                :message="showErrors[key]['date']"
                :type="showErrors[key]['date'] ? 'is-danger' : ''"
              >
                <datepicker
                  size="is-small"
                  :value="
                    contract.date
                      ? new Date(contract.date)
                      : new Date()
                  "
                  @input="$set(contract, 'date', formatDate($event))"
                ></datepicker>
              </b-field>
            </td>
            <td>
              <b-field
                :message="showErrors[key]['notes']"
                :type="showErrors[key]['notes'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="contract.notes"
                  size="is-small"
                  @focus="modalEdit(contract, 'notes')"
                ></b-input>
              </b-field>
            </td>
            <td>
              <button class="button is-small" @click="formData.splice(key, 1)">
                <b-icon icon="minus-circle" type="is-danger" />
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="9">
              <div class="buttons">
                <button
                  class="button is-success is-small"
                  @click="formData.push({ customer: customerId })"
                >
                  <b-icon icon="plus"></b-icon>
                  <span>Aggiungi contratto corso</span>
                </button>
                <button
                  v-if="formHasEdits"
                  class="button is-small"
                  @click="reset"
                >
                  <b-icon icon="undo"></b-icon>
                  <span>Annulla</span>
                </button>
                <button
                  v-if="formHasEdits"
                  class="button is-small is-primary"
                  type="submit"
                  @click="submit()"
                >
                  <b-icon icon="save"></b-icon>
                  <span>Salva</span>
                </button>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </b-collapse>
</template>

<script>
import cloneDeep from "lodash/cloneDeep"
import { get, call } from "vuex-pathify"

import dateHelpers from "@/mixins/dateHelpers"

export default {
  mixins: [dateHelpers],
  props: {
    customerId: {
      type: Number,
      required: true
    },
    courseContracts: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      componentKey: 0, // used to force rerender
      formData: cloneDeep(this.courseContracts),
      errors: []
    }
  },
  computed: {
    courses: get("courseTypes/courseTypes"),
    formHasEdits() {
      return (
        JSON.stringify(this.courseContracts) != JSON.stringify(this.formData)
      )
    },
    showErrors() {
      if (this.errors.length > 0) {
        return this.errors
      } else {
        let elements = []
        this.formData.forEach(() => {
          elements.push({})
        })
        return elements
      }
    }
  },
  mounted() {
    this.fetchProducts()
  },
  methods: {
    fetchProducts: call("courseTypes/all"),
    submitAction: call("courseContracts/update"),
    reset() {
      this.errors = []
      this.formData = cloneDeep(this.courseContracts)
      this.componentKey += 1
    },
    async submit() {
      try {
        await this.submitAction({
          customerId: this.customerId,
          data: this.formData
        })
        this.reset()
        this.$toast.open({
          message: "Modificato con successo",
          type: "is-success"
        })
      } catch (response) {
        // show errors in form
        this.errors = response.data
      }
    }
  }
}
</script>
